module.exports = __webpack_public_path__ + "static/Connector-88de0bae0f17bf6a541c1f8ad4ad5252.svg";